import { Component, Input, forwardRef, OnInit } from '@angular/core';
import { FilterSetService } from '../../../services/filter-set.service';
import { BbFilterConfiguration } from '../bb-filters/bb-filters.component';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { bbGenerateShortId } from '../../../shared/utils/bbGenerateShortId.util';

@Component({
	selector: 'bb-filter-set',
	templateUrl: './bb-filter-set.component.html',
	styleUrls: ['./bb-filter-set.component.scss'],
	providers: [{
		provide: NG_VALUE_ACCESSOR,
		multi: true,
		useExisting: forwardRef(() => BbFilterSetComponent)
	}]
})

export class BbFilterSetComponent implements ControlValueAccessor, OnInit {
	@Input() useMatFields = false;
	@Input() filterConfig: BbFilterConfiguration;
	filterSetString: any;
	groups: any;
	propagateChange: any;

	constructor(private filterSetService: FilterSetService) {
	}

	ngOnInit() {
		if (this.filterConfig) {
			this.filterSetService.setFilterConfig(this.filterConfig.filters);
		}
	}

	addGroup() {
		if (typeof this.groups === 'undefined' || this.groups === null) {
			this.groups = [];
		}

		this.groups.push({
			filters: [],
		});
		this.addFilter(this.groups.length - 1);
	}

	addFilter(groupIndex: number) {
		if (typeof this.groups[groupIndex].filters === 'undefined' || this.groups[groupIndex].filters === null) {
			this.groups[groupIndex].filters = [];
		}
		this.groups[groupIndex].filters.push({
			id: bbGenerateShortId(),
			type: '',
			field: '',
			operator: '',
			value: []
		});
	}

	deleteFilter(groupIndex: number, index: number) {
		this.groups[groupIndex].filters.splice(index, 1);

		if (this.groups[groupIndex].filters.length === 0) {
			this.groups.splice(groupIndex, 1);
		}
		this.filterChange();
	}

	filterChange(propagate: boolean = true) {
		const filterSet: any = [];

		this.groups.forEach((group: any) => {
			let filters = group.filters;
			filters = filters.filter((f: any) => !!f.value).map((f: any) => [f.entity || 'mediaclip', f.field, f.operator, [f.value]]);
			filterSet.push(filters);
		});

		if (propagate) {
			this.propagateChange(this.groups);
		}
	}

	writeValue(value: any) {
		this.groups = value;
		if (this.groups) {
			this.filterChange(false);
		}
	}

	registerOnChange(fn: any) {
		this.propagateChange = fn;
	}

	registerOnTouched() {
	}

}
